<div
  [class.error]="type() === 'error'"
  [class.info]="type() === 'info'"
  [class.warning]="type() === 'warning'"
  [class.success]="type() === 'success'"
  class="alert">
  <span class="icon">
    <mat-icon [svgIcon]="getIcon(type())"> </mat-icon>
  </span>

  <div>
    <div class="title">{{ title() }}</div>
    <div class="text"><ng-content></ng-content></div>
  </div>
</div>
